import Raven from 'raven-js';
import { Metrics } from '../metrics/Metrics';

// Not a complete type, but supplies us with the fields we need.

export const parseUpdateResponse = (response, requestedUpdates) => {
  const parsedResponse = {};
  for (const {
    objectId,
    properties
  } of response) {
    parsedResponse[objectId] = {};
    const request = requestedUpdates[objectId];
    for (const [propertyName, update] of Object.entries(properties)) {
      let value = update.value;
      const {
        sourceId
      } = update;

      // Encrypted values are not returned by the endpoint, so we rely on
      // the requested value since it's our best guess at what the value should be.
      if (update.isEncrypted) {
        value = request[propertyName];
      }
      parsedResponse[objectId][propertyName] = {
        value,
        sourceId
      };
    }
    if (Object.keys(parsedResponse[objectId]).length === 0) {
      Metrics.counter('autosave-empty-parsed-updates').increment();
    }
  }
  return parsedResponse;
};
export const savePropertyValues = (objectTypeId, updates, httpClient) => {
  // TODO: consider using the client-types package to type this data
  // import { UpdateBatchResponse } from 'inbounddb-objects-service-types/InboundDbObjects-Service-v1/types';
  // at the moment, this type is really lacking since the PropertiesWrapper type is just Record<string, unknown>
  // and the extra dep is not worth it.
  // sswindell @ 10-17-2024

  return httpClient.put(`inbounddb-objects/v1/crm-objects/${encodeURIComponent(objectTypeId)}`, {
    data: Object.entries(updates).map(([objectId, update]) => ({
      objectId,
      propertyValues: Object.entries(update).map(([name, value]) => ({
        name,
        value
      }))
    })),
    keepalive: true
  }).then(response => {
    Metrics.counter('savepropertyvalues-success').increment();
    return parseUpdateResponse(response, updates);
  }).catch(e => {
    Metrics.counter('savepropertyvalues-failure').increment();
    Raven.captureException(e, {
      extra: {
        objectTypeId,
        updates
      }
    });
    throw e;
  });
};